// Equipment category colours, from the design system's cat-* tokens.
// They follow the light and dark themes on their own, because each colour is
// a CSS variable rather than a fixed hex. Text on a category fill uses
// `hsl(var(--on-cat))`.
//
// A category without a token takes cat-other. Do not invent hues.

const TOKEN_FOR_CATEGORY = {
  camera: 'camera',
  lenses: 'lenses',
  lens: 'lenses',
  lighting: 'lighting',
  audio: 'audio',
  grip: 'grip',
  monitors: 'monitors',
  monitor: 'monitors',
  accessories: 'accessories',
  other: 'other',
};

const tokenColor = (token) => `hsl(var(--cat-${token}))`;

export const CATEGORY_COLORS = {
  Camera: tokenColor('camera'),
  Lenses: tokenColor('lenses'),
  Lens: tokenColor('lenses'),
  Lighting: tokenColor('lighting'),
  Audio: tokenColor('audio'),
  Grip: tokenColor('grip'),
  Monitors: tokenColor('monitors'),
  Monitor: tokenColor('monitors'),
  Accessories: tokenColor('accessories'),
  Other: tokenColor('other'),
};

/** The colour for a category, as a CSS colour string usable in style={} and SVG fills. */
export function getCategoryColor(categoryName) {
  const token = TOKEN_FOR_CATEGORY[(categoryName || '').trim().toLowerCase()] || 'other';
  return tokenColor(token);
}

/** Text colour that reads on any category fill. */
export const ON_CATEGORY_COLOR = 'hsl(var(--on-cat))';

// Get all category colors as an object (for components that need the full map)
export function getAllCategoryColors() {
  return { ...CATEGORY_COLORS };
}
